import React from 'react';
import { User } from 'lucide-react';

const ProfileSettings: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="rounded-2xl bg-gradient-to-br from-green-500 to-emerald-600 p-3">
          <User className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Profile Settings</h1>
          <p className="text-gray-600">Manage your public profile and privacy settings</p>
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
        <p className="text-gray-600">Profile settings content will be implemented here.</p>
      </div>
    </div>
  );
};

export default ProfileSettings;
